import { OuiSymbolComponent } from '@aiz-gl/omni-ui';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TEXT } from '../../constants/text';

@Component({
  selector: 'app-downloads-button',
  imports: [OuiSymbolComponent],
  standalone: true,
  template: `
    <button type="button" class="downloads-pill" (click)="navigate()" data-testid="downloads-button">
      <Symbol name="download" class="downloads-pill__icon"></Symbol>
      <span>{{ T.common.downloads }}</span>
    </button>
  `,
  styles: [
    `
      .downloads-pill {
        appearance: none;
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.25rem 0.875rem;
        background: var(--surface);
        border: 1px solid var(--border);
        border-radius: 999px;
        color: var(--text);
        font: inherit;
        font-size: 0.85rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 150ms ease, border-color 150ms ease;
      }

      .downloads-pill:hover {
        background: var(--subtle);
        border-color: var(--border-light);
      }

      .downloads-pill__icon {
        font-size: 1.1rem !important;
      }
    `,
  ],
})
export class DownloadsButtonComponent {
  protected readonly T = TEXT;
  private readonly router = inject(Router);

  navigate(): void {
    void this.router.navigate(['/downloads']);
  }
}
